import moment from 'moment';
import _ from 'lodash';
import IncomesProxy from '@/proxies/Cashier/IncomesProxy';
import { DATETIME_ISO } from '../../constants/dates';
import { prepareValidationMessages } from '../../utils';

export default {
  data() {
    return {
      errorsIncomeDialog: null,
    };
  },
  methods: {
    onActionIncomeDialog(item) {
      this.errorsIncomeDialog = {};
      if (_.isObject(item)) {
        let income = new IncomesProxy();
        const incomeData = {};
        incomeData.datetime = moment(item.datetime).format(DATETIME_ISO);
        incomeData.note = item.note;
        incomeData.sum = item.sum;
        incomeData.type = item.type;
        if (item.uuid) {
          incomeData.uuid = item.uuid;
        }
        if (item.uuid) {
          console.log(item.uuid);
          income = income.update(item.uuid, incomeData);
        } else {
          income = income.create(incomeData);
        }

        income.then((response) => {
          this.currentEditableItem = response.data.data.income;
          this.$store.dispatch('page/displaySnackbar', {
            text: `Доход сохранен. ${this.currentEditableItem.uuid}`,
            color: 'teal lighten-3',
            timeout: 20000,
          });
          this.$store.dispatch('page/updateCurrentPageContent');
          this.isShowIncomeDialog = false;
        })
          .catch((response) => {
            console.log('fhgh');
            let errors = [];
            if (response && response.data && response.data.data) {
              this.errorsIncomeDialog = prepareValidationMessages(response.data.data);
              errors = Object.values(this.errorsIncomeDialog);
            }
            if (errors.length) {
              this.$store.dispatch('page/displaySnackbar', {
                text: `Ошибка. ${errors[0]}`,
                color: 'red darken-3',
                timeout: 20000,
              });
            } else {
              this.$store.dispatch('page/displaySnackbar', {
                text: 'Непредвиденная ошибка. Обратитесь к разработчику',
                color: 'red darken-3',
                timeout: 20000,
              });
              console.error(response);
            }
          })
          .finally(() => {
          });
      }
    },
  },
};
